// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_1_wrapper__3SXRf"};